import { useModalContext } from 'components/Modal/ModalProvider';

import { useScrollLock } from 'components/Modal/Modal.hooks';

import { Portal } from 'components/Portal';
import { Modal } from 'components/Modal';
import { WelcomeModal } from 'components/Modal/ModalTypes/WelcomeModal';
import { InfoModal } from 'components/Modal/ModalTypes/InfoModal';
import { SuccessModal } from 'components/Modal/ModalTypes/SuccessModal';
import { RemoveModal } from 'components/Modal/ModalTypes/RemoveModal';

export const ModalRoot = () => {
  const { modal, closeModal } = useModalContext();

  useScrollLock(!!modal.type);

  if (!modal.type) return null;

  return (
    <Portal>
      <Modal onClose={closeModal}>
        {modal.type === 'welcome' && <WelcomeModal />}
        {modal.type === 'info' && <InfoModal {...modal.props} />}
        {modal.type === 'success' && <SuccessModal {...modal.props}/>}
        {modal.type === 'remove' && <RemoveModal {...modal.props} />}
      </Modal>
    </Portal>
  );
};